export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  totalAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    quantityAvailable
    availableForSale
    sku
    price {
      amount
      currencyCode
    }
    product {
      ... on Product {
        title
        handle
        id
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        images(first: 1) {
          edges {
            node {
              src: url(transform: { maxHeight: 200, maxWidth: 200 })
            }
          }
        }
        cartDrawerItemBodyPromoBadge: metafield(namespace: "cart_drawer", key: "promo_badge") {
          value
        }
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
attributes {
  key
  value
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variant = `
availableForSale
id
quantityAvailable
sku
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
`;

export const externalVideo = `
id
embeddedUrl
host
previewImage {
  alt: altText
  src: url
}
`;

export const video = `
id
sources {
  url
  height
  width
}
previewImage {
  alt: altText
  src: url
}
`;

export const image = `
alt: altText
height
id
src: url(transform: { preferredContentType: WEBP })
width
`;

export const bundle = `
availableForSale
title
images(first: 1) {
  edges {
    node {
      ${image}
    }
  }
}
options {
  id
  name
  values
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 1) {
  edges {
    node {
      ${variant}
    }
  }
}
`;

export const product = `
availableForSale
handle
id
title
description
tags
images(first: 50) {
  edges {
    node {
      ${image}
    }
  }
}
media(first: 20) {
  edges {
    node {
      mediaContentType
      alt
      ... on ExternalVideo {
        ${externalVideo}
      }
      ... on MediaImage {
        image {
          ${image}
        }
      }
      ... on Video {
        ${video}
      }
    }
  }
}
options {
  id
  name
  values
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 1) {
  edges {
    node {
      ${variant}
    }
  }
}
subtitle: metafield(namespace: "details", key: "subtitle") {
  value
}
freeShippingText: metafield(namespace: "free_shipping", key: "text") {
  value
}
freeShippingStandard: metafield(namespace: "free_shipping", key: "standard") {
  value
}
swatchColor: metafield(namespace: "details", key: "swatch_color") {
  value
}
subtitle: metafield(namespace: "details", key: "subtitle") {
  value
}
smellsLike: metafield(namespace: "details", key: "smells_like") {
 value
}
feelsLike: metafield(namespace: "details", key: "feels_like") {
 value
}
benefits: metafield(namespace: "details", key: "benefits") {
  value
}
promoTitle1: metafield(namespace: "details", key: "promo_message_title_01") {
  value
}
promoContent1: metafield(
  namespace: "details", key: "promo_message_content_01") {
  value
}
promoTitle2: metafield(namespace: "details", key: "promo_message_title_02") {
  value
}
promoContent2: metafield(
  namespace: "custom", key: "promo_message_content_02") {
  value
}
cartDrawerItemBodyPromoBadge: metafield(namespace: "cart_drawer", key: "promo_badge") {
  value
}
singleBundleItems: metafield(namespace: "single_bundle", key: "items") {
  references(first: 10) {
    edges {
      node {
        ... on Metaobject {
        fields {
            key
            value
          }
        }
      }
    }
  }
}
`;

export const article = `
id
excerpt
content
title
handle
image {
  ${image}
}
cardTitle: metafield(namespace: "custom", key: "card_title") {
  value
}
`;
